import {PageFragment, PageFragmentProps, PageFragmentState} from "../../../shared/PageFragment";
import {ChatParticipant, ChatThread, ParticipantType} from "./chat/types";
import {DirectoryUsers} from "../../../shared/directory/types";

export type BaseChatThreadFragmentProps = PageFragmentProps&{
  thread: ChatThread,
}

export type BaseChatThreadFragmentState = PageFragmentState&{
  participants: ChatParticipant[],
}

export abstract class BaseChatThreadFragment<P extends BaseChatThreadFragmentProps = BaseChatThreadFragmentProps, S extends BaseChatThreadFragmentState=BaseChatThreadFragmentState> extends PageFragment<P, S> {

  componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot?: any) {
    super.componentDidUpdate(prevProps, prevState, snapshot);
    if (prevProps.thread.id !== this.props.thread.id) {
      this.reload();
    }
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    const participants: ChatParticipant[] = [];
    for (const key of this.props.thread.participantKeys) {
      switch (key.type) {
        case ParticipantType.DIRECTORY_USER:
          participants.push(new ChatParticipant(key, await DirectoryUsers.getInstance().getOrLoadItem(key.id)));
          break;
      }
    }
    this.setState({
      participants: participants,
    });
  }
}